import { useContext } from "react";
import Context from "./Context";
import LoggedInHeader from "./components/pages/loggedIn/LoggedInHeader";
import styled from "styled-components";
import WithBackground from "./components/core/boilerplate/WithBackground";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100vw;
`;

const ContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 30px;
  flex: 1;
  min-width: 0;
`;

const MobileMain = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

export default function WithLoggedInHeader({ children }) {
  const { loggedInUserID, isMobile, themeState } = useContext(Context);

  if (!loggedInUserID) return children;

  if (isMobile) {
    return (
      <ContainerMobile>
        <LoggedInHeader />
        <MobileMain>{children}</MobileMain>
      </ContainerMobile>
    );
  }

  // return null;
  return (
    <Container>
      <LoggedInHeader />
      <Main>{children}</Main>
    </Container>
  );
}
